import { render, staticRenderFns } from "./ShopsPage.vue?vue&type=template&id=551a5b4a&scoped=true&"
import script from "./ShopsPage.vue?vue&type=script&lang=js&"
export * from "./ShopsPage.vue?vue&type=script&lang=js&"
import style0 from "./ShopsPage.vue?vue&type=style&index=0&id=551a5b4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551a5b4a",
  null
  
)

export default component.exports